import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IPageInfo, IBookingImportVersion } from '@api'
import { PageInfoFragment, BookingImportVersionFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  node: {
    createdAt: string
    importedBy: string
    versions: {
      pageInfo: IPageInfo
      edges: { node: IBookingImportVersion }[]
    }
  }
}

interface IBookingDetails {
  details: IBookingImportVersion[]
  pageInfo: IPageInfo
  createdAt: string
  importedBy: string
}

const mutateHandler = handleFetchResult<IPayload, IBookingDetails>({
  handler: ({
    node: {
      versions: { pageInfo, edges },
      createdAt,
      importedBy,
    },
  }) => ({
    details: edges.map(({ node }: { node: IBookingImportVersion }) => node),
    pageInfo,
    createdAt,
    importedBy,
  }),
  name: 'Booking',
})

export default function details(
  id: string,
  after: string | null,
  events: string[]
): Promise<IBookingDetails> {
  return client.gql.query({ query, variables: { id, after, events } }).then(mutateHandler)
}

const query = gql`
  query node($id: ID!, $after: String, $events: [BookingImportEvent]!) {
    node(id: $id) {
      ... on BookingImport {
        createdAt
        importedBy
        versions(first: 30, after: $after, events: $events) {
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...BookingImportVersionFragment
            }
          }
        }
      }
    }
  }
  ${PageInfoFragment}
  ${BookingImportVersionFragment}
`
